module.exports = __webpack_public_path__ + "img/stop-button.b0698710.png";